/**
 * A listing of every Pokemon that can be obtained from Pokemon GO and how the can be obtained.
 * If a Pokemon is not listed here, it cannot be obtained from Pokemon GO.
 *
 * Key:
 * - Origin:
 * - wild: Can be found in the overworld, either as a regular spawn or through a similar source such as GO Snapshot
 * - egg: Hatches from 2, 5, or 10 km eggs
 * - giovanni: Shadow Pokemon rescued from Giovanni and purified
 * - 12kmegg: Hatches from a 12 km egg, which is obtained from Team GO Rocket Leaders which unlock at level 8
 * - raid: Caught from defeating a raid boss (also used for GBL encounters)
 * - research: Reward from field research, special research, or research breakthrough
 * If the Pokemon is obtainable from the wild, other sources do not need to be included due to redundancy.
 * For shinies that can't be obtained from the wild, all other sources should be included.
 *
 * - Shiny origin restrictions:
 * - noshiny: This Pokemon's shiny form is unavailable in Pokemon GO
 * - (currently unused) nowildshiny: This Pokemon can't be obtained as shiny from the wild
 *
 * - Trade restrictions:
 * - notrade: This Pokemon cannot be traded at all
 * - specialtrade: This Pokemon must be traded in a special trade
 *
 * Certain sources have been excluded from this list, which are:
 * - GO Battle League: same level and IV floor as raid bosses, and all from GO Battle League have also been in raids
 * - Shadow Pokemon: most can also be obtained from the wild, and those that can't are from defeating Giovanni, which
 *   is handled as as its own encounter
 */
export const PokemonGoData: import('../sim/dex-species').PokemonGoDataTable = {
	bulbasaur: { encounters: ['wild'] },
	ivysaur: { encounters: ['wild'] },
	venusaur: { encounters: ['wild'] },
	charmander: { encounters: ['wild'] },
	charmeleon: { encounters: ['wild'] },
	charizard: { encounters: ['wild'] },
	squirtle: { encounters: ['wild'] },
	wartortle: { encounters: ['wild'] },
	blastoise: { encounters: ['wild'] },
	caterpie: { encounters: ['wild'] },
	metapod: { encounters: ['wild'] },
	butterfree: { encounters: ['wild'] },
	weedle: { encounters: ['wild'] },
	kakuna: { encounters: ['wild'] },
	beedrill: { encounters: ['wild'] },
	pidgey: { encounters: ['wild'] },
	pidgeotto: { encounters: ['wild'] },
	pidgeot: { encounters: ['wild'] },
	rattata: { encounters: ['wild'] },
	rattataalola: { encounters: ['wild'] },
	raticate: { encounters: ['wild'] },
	raticatealola: { encounters: ['wild'] },
	spearow: { encounters: ['wild'] },
	fearow: { encounters: ['wild'] },
	ekans: { encounters: ['wild'] },
	arbok: { encounters: ['wild'] },
	pikachu: { encounters: ['wild'] },
	raichu: { encounters: ['wild'] },
	raichualola: { encounters: ['wild'] },
	sandshrew: { encounters: ['wild'] },
	sandshrewalola: { encounters: ['wild'] },
	sandslash: { encounters: ['wild'] },
	sandslashalola: { encounters: ['wild'] },
	nidoranf: { encounters: ['wild'] },
	nidorina: { encounters: ['wild'] },
	nidoqueen: { encounters: ['wild'] },
	nidoranm: { encounters: ['wild'] },
	nidorino: { encounters: ['wild'] },
	nidoking: { encounters: ['wild'] },
	clefairy: { encounters: ['wild'] },
	clefable: { encounters: ['wild'] },
	vulpix: { encounters: ['wild'] },
	vulpixalola: { encounters: ['wild'] },
	ninetales: { encounters: ['wild'] },
	ninetalesalola: { encounters: ['wild'] },
	jigglypuff: { encounters: ['wild'] },
	wigglytuff: { encounters: ['wild'] },
	zubat: { encounters: ['wild'] },
	golbat: { encounters: ['wild'] },
	oddish: { encounters: ['wild'] },
	gloom: { encounters: ['wild'] },
	vileplume: { encounters: ['wild'] },
	paras: { encounters: ['wild'] },
	parasect: { encounters: ['wild'] },
	venonat: { encounters: ['wild'] },
	venomoth: { encounters: ['wild'] },
	diglett: { encounters: ['wild'] },
	diglettalola: { encounters: ['wild'] },
	dugtrio: { encounters: ['wild'] },
	dugtrioalola: { encounters: ['wild'] },
	meowth: { encounters: ['wild'] },
	meowthalola: { encounters: ['wild'] },
	meowthgalar: { encounters: ['wild'] },
	persian: { encounters: ['wild'] },
	persianalola: { encounters: ['wild'] },
	psyduck: { encounters: ['wild'] },
	golduck: { encounters: ['wild'] },
	mankey: { encounters: ['wild'] },
	primeape: { encounters: ['wild'] },
	growlithe: { encounters: ['wild'] },
	growlithehisui: { encounters: ['wild'] },
	arcanine: { encounters: ['wild'] },
	arcaninehisui: { encounters: ['wild'] },
	poliwag: { encounters: ['wild'] },
	poliwhirl: { encounters: ['wild'] },
	poliwrath: { encounters: ['wild'] },
	abra: { encounters: ['wild'] },
	kadabra: { encounters: ['wild'] },
	alakazam: { encounters: ['wild'] },
	machop: { encounters: ['wild'] },
	machoke: { encounters: ['wild'] },
	machamp: { encounters: ['wild'] },
	bellsprout: { encounters: ['wild'] },
	weepinbell: { encounters: ['wild'] },
	victreebel: { encounters: ['wild'] },
	tentacool: { encounters: ['wild'] },
	tentacruel: { encounters: ['wild'] },
	geodude: { encounters: ['wild'] },
	geodudealola: { encounters: ['wild'] },
	graveler: { encounters: ['wild'] },
	graveleralola: { encounters: ['wild'] },
	golem: { encounters: ['wild'] },
	golemalola: { encounters: ['wild'] },
	ponyta: { encounters: ['wild'] },
	ponytagalar: { encounters: ['wild'] },
	rapidash: { encounters: ['wild'] },
	rapidashgalar: { encounters: ['wild'] },
	slowpoke: { encounters: ['wild'] },
	slowpokegalar: { encounters: ['wild'] },
	slowbro: { encounters: ['wild'] },
	slowbrogalar: { encounters: ['wild'] },
	magnemite: { encounters: ['wild'] },
	magneton: { encounters: ['wild'] },
	farfetchd: { encounters: ['wild'] },
	farfetchdgalar: { encounters: ['wild'] },
	doduo: { encounters: ['wild'] },
	dodrio: { encounters: ['wild'] },
	seel: { encounters: ['wild'] },
	dewgong: { encounters: ['wild'] },
	grimer: { encounters: ['wild'] },
	grimeralola: { encounters: ['wild'] },
	muk: { encounters: ['wild'] },
	mukalola: { encounters: ['wild'] },
	shellder: { encounters: ['wild'] },
	cloyster: { encounters: ['wild'] },
	gastly: { encounters: ['wild'] },
	haunter: { encounters: ['wild'] },
	gengar: { encounters: ['wild'] },
	onix: { encounters: ['wild'] },
	drowzee: { encounters: ['wild'] },
	hypno: { encounters: ['wild'] },
	krabby: { encounters: ['wild'] },
	kingler: { encounters: ['wild'] },
	voltorb: { encounters: ['wild'] },
	voltorbhisui: { encounters: ['wild'] },
	electrode: { encounters: ['wild'] },
	electrodehisui: { encounters: ['wild'] },
	exeggcute: { encounters: ['wild'] },
	exeggutor: { encounters: ['wild'] },
	exeggutoralola: { encounters: ['wild'] },
	cubone: { encounters: ['wild'] },
	marowak: { encounters: ['wild'] },
	marowakalola: { encounters: ['wild'] },
	hitmonlee: { encounters: ['wild'] },
	hitmonchan: { encounters: ['wild'] },
	lickitung: { encounters: ['wild'] },
	koffing: { encounters: ['wild'] },
	weezing: { encounters: ['wild'] },
	weezinggalar: { encounters: ['wild'] },
	rhyhorn: { encounters: ['wild'] },
	rhydon: { encounters: ['wild'] },
	chansey: { encounters: ['wild'] },
	tangela: { encounters: ['wild'] },
	kangaskhan: { encounters: ['wild'] },
	horsea: { encounters: ['wild'] },
	seadra: { encounters: ['wild'] },
	goldeen: { encounters: ['wild'] },
	seaking: { encounters: ['wild'] },
	staryu: { encounters: ['wild'] },
	starmie: { encounters: ['wild'] },
	mrmime: { encounters: ['wild'] },
	mrmimegalar: { encounters: ['wild'] },
	scyther: { encounters: ['wild'] },
	jynx: { encounters: ['wild'] },
	electabuzz: { encounters: ['wild'] },
	magmar: { encounters: ['wild'] },
	pinsir: { encounters: ['wild'] },
	tauros: { encounters: ['wild'] },
	magikarp: { encounters: ['wild'] },
	gyarados: { encounters: ['wild'] },
	ditto: { encounters: ['wild'] },
	eevee: { encounters: ['wild'] },
	vaporeon: { encounters: ['wild'] },
	jolteon: { encounters: ['wild'] },
	flareon: { encounters: ['wild'] },
	porygon: { encounters: ['wild'] },
	omanyte: { encounters: ['wild'] },
	omastar: { encounters: ['wild'] },
	kabuto: { encounters: ['wild'] },
	kabutops: { encounters: ['wild'] },
	aerodactyl: { encounters: ['wild'] },
	snorlax: { encounters: ['wild'] },
	articuno: { encounters: ['wild'] },
	articunogalar: { encounters: ['wild'] },
	zapdos: { encounters: ['wild'] },
	zapdosgalar: { encounters: ['wild'] },
	moltres: { encounters: ['wild'] },
	moltresgalar: { encounters: ['wild'] },
	dratini: { encounters: ['wild'] },
	dragonair: { encounters: ['wild'] },
	dragonite: { encounters: ['wild'] },
	mewtwo: {
		encounters: ['giovanni', 'raid', 'research', 'specialtrade'],
		LGPERestrictiveMoves: {
			amnesia: 44,
			swift: 33,
			psybeam: 22,
			mist: 11,
			teleport: 1,
			confuseray: 1,
			confusion: 1,
			disable: 1,
		},
	},
	mew: {
		encounters: ['research', 'notrade'],
		LGPERestrictiveMoves: {
			barrier: 44,
			psywave: 33,
			amnesia: 22,
			swift: 11,
			pound: 1,
			confusion: 1,
			mimic: 1,
		},
	},
	chikorita: { encounters: ['wild'] },
	bayleef: { encounters: ['wild'] },
	meganium: { encounters: ['wild'] },
	cyndaquil: { encounters: ['wild'] },
	quilava: { encounters: ['wild'] },
	typhlosion: { encounters: ['wild'] },
	typhlosionhisui: { encounters: ['raid'] },
	totodile: { encounters: ['wild'] },
	croconaw: { encounters: ['wild'] },
	feraligatr: { encounters: ['wild'] },
	sentret: { encounters: ['wild'] },
	furret: { encounters: ['wild'] },
	hoothoot: { encounters: ['wild'] },
	noctowl: { encounters: ['wild'] },
	ledyba: { encounters: ['wild'] },
	ledian: { encounters: ['wild'] },
	spinarak: { encounters: ['wild'] },
	ariados: { encounters: ['wild'] },
	crobat: { encounters: ['wild'] },
	chinchou: { encounters: ['wild'] },
	lanturn: { encounters: ['wild'] },
	pichu: { encounters: ['egg'] },
	cleffa: { encounters: ['egg'] },
	igglybuff: { encounters: ['egg'] },
	togepi: { encounters: ['egg'] },
	togetic: { encounters: ['wild'] },
	natu: { encounters: ['wild'] },
	xatu: { encounters: ['wild'] },
	mareep: { encounters: ['wild'] },
	flaaffy: { encounters: ['wild'] },
	ampharos: { encounters: ['wild'] },
	bellossom: { encounters: ['wild'] },
	marill: { encounters: ['wild'] },
	azumarill: { encounters: ['wild'] },
	sudowoodo: { encounters: ['wild'] },
	politoed: { encounters: ['wild'] },
	hoppip: { encounters: ['wild'] },
	skiploom: { encounters: ['wild'] },
	jumpluff: { encounters: ['wild'] },
	aipom: { encounters: ['wild'] },
	sunkern: { encounters: ['wild'] },
	sunflora: { encounters: ['wild'] },
	yanma: { encounters: ['wild'] },
	wooper: { encounters: ['wild'] },
	wooperpaldea: { encounters: ['wild'] },
	quagsire: { encounters: ['wild'] },
	espeon: { encounters: ['wild'] },
	umbreon: { encounters: ['wild'] },
	murkrow: { encounters: ['wild'] },
	slowking: { encounters: ['wild'] },
	slowkinggalar: { encounters: ['wild'] },
	misdreavus: { encounters: ['wild'] },
	unown: { encounters: ['wild'] },
	unownb: { encounters: ['wild'] },
	unownc: { encounters: ['wild'] },
	unownd: { encounters: ['wild'] },
	unowne: { encounters: ['wild'] },
	unownf: { encounters: ['wild'] },
	unowng: { encounters: ['wild'] },
	unownh: { encounters: ['wild'] },
	unowni: { encounters: ['wild'] },
	unownj: { encounters: ['wild'] },
	unownk: { encounters: ['wild', 'noshiny'] },
	unownl: { encounters: ['wild'] },
	unownm: { encounters: ['wild'] },
	unownn: { encounters: ['wild'] },
	unowno: { encounters: ['wild'] },
	unownp: { encounters: ['wild'] },
	unownq: { encounters: ['wild', 'noshiny'] },
	unownr: { encounters: ['wild'] },
	unowns: { encounters: ['wild'] },
	unownt: { encounters: ['wild'] },
	unownu: { encounters: ['wild'] },
	unownv: { encounters: ['wild'] },
	unownw: { encounters: ['wild', 'noshiny'] },
	unownx: { encounters: ['wild'] },
	unowny: { encounters: ['wild'] },
	unownz: { encounters: ['wild', 'noshiny'] },
	unownexclamation: { encounters: ['wild'] },
	unownquestion: { encounters: ['wild'] },
	wobbuffet: { encounters: ['wild'] },
	girafarig: { encounters: ['wild'] },
	pineco: { encounters: ['wild'] },
	forretress: { encounters: ['wild'] },
	dunsparce: { encounters: ['wild'] },
	gligar: { encounters: ['wild'] },
	steelix: { encounters: ['wild'] },
	snubbull: { encounters: ['wild'] },
	granbull: { encounters: ['wild'] },
	qwilfish: { encounters: ['wild'] },
	qwilfishhisui: { encounters: ['wild'] },
	scizor: { encounters: ['wild'] },
	shuckle: { encounters: ['wild'] },
	heracross: { encounters: ['wild'] },
	sneasel: { encounters: ['wild'] },
	sneaselhisui: { encounters: ['wild'] },
	teddiursa: { encounters: ['wild'] },
	ursaring: { encounters: ['wild'] },
	slugma: { encounters: ['wild'] },
	magcargo: { encounters: ['wild'] },
	swinub: { encounters: ['wild'] },
	piloswine: { encounters: ['wild'] },
	corsola: { encounters: ['wild'] },
	corsolagalar: { encounters: ['egg'] },
	remoraid: { encounters: ['wild'] },
	octillery: { encounters: ['wild'] },
	delibird: { encounters: ['wild'] },
	mantine: { encounters: ['wild'] },
	skarmory: { encounters: ['wild'] },
	houndour: { encounters: ['wild'] },
	houndoom: { encounters: ['wild'] },
	kingdra: { encounters: ['wild'] },
	phanpy: { encounters: ['wild'] },
	donphan: { encounters: ['wild'] },
	porygon2: { encounters: ['wild'] },
	stantler: { encounters: ['wild'] },
	smeargle: { encounters: ['wild'] },
	tyrogue: { encounters: ['egg'] },
	hitmontop: { encounters: ['wild'] },
	smoochum: { encounters: ['egg', 'research'] },
	elekid: { encounters: ['egg', 'research'] },
	magby: { encounters: ['egg'] },
	miltank: { encounters: ['wild'] },
	blissey: { encounters: ['wild'] },
	raikou: { encounters: ['wild'] },
	entei: { encounters: ['wild'] },
	suicune: { encounters: ['wild'] },
	larvitar: { encounters: ['wild'] },
	pupitar: { encounters: ['wild'] },
	tyranitar: { encounters: ['wild'] },
	lugia: { encounters: ['giovanni', 'raid', 'research', 'specialtrade'] },
	hooh: { encounters: ['giovanni', 'raid', 'research', 'specialtrade'] },
	celebi: { encounters: ['research', 'notrade'] },
	treecko: { encounters: ['wild'] },
	grovyle: { encounters: ['wild'] },
	sceptile: { encounters: ['wild'] },
	torchic: { encounters: ['wild'] },
	combusken: { encounters: ['wild'] },
	blaziken: { encounters: ['wild'] },
	mudkip: { encounters: ['wild'] },
	marshtomp: { encounters: ['wild'] },
	swampert: { encounters: ['wild'] },
	poochyena: { encounters: ['wild'] },
	mightyena: { encounters: ['wild'] },
	zigzagoon: { encounters: ['wild'] },
	zigzagoongalar: { encounters: ['wild'] },
	linoone: { encounters: ['wild'] },
	linoonegalar: { encounters: ['wild'] },
	wurmple: { encounters: ['wild'] },
	silcoon: { encounters: ['wild'] },
	beautifly: { encounters: ['wild'] },
	cascoon: { encounters: ['wild'] },
	dustox: { encounters: ['wild'] },
	lotad: { encounters: ['wild'] },
	lombre: { encounters: ['wild'] },
	ludicolo: { encounters: ['wild'] },
	seedot: { encounters: ['wild'] },
	nuzleaf: { encounters: ['wild'] },
	shiftry: { encounters: ['wild'] },
	taillow: { encounters: ['wild'] },
	swellow: { encounters: ['wild'] },
	wingull: { encounters: ['wild'] },
	pelipper: { encounters: ['wild'] },
	ralts: { encounters: ['wild'] },
	kirlia: { encounters: ['wild'] },
	gardevoir: { encounters: ['wild'] },
	surskit: { encounters: ['wild'] },
	masquerain: { encounters: ['wild'] },
	shroomish: { encounters: ['wild'] },
	breloom: { encounters: ['wild'] },
	slakoth: { encounters: ['wild'] },
	vigoroth: { encounters: ['wild'] },
	slaking: { encounters: ['wild'] },
	nincada: { encounters: ['wild'] },
	ninjask: { encounters: ['wild'] },
	shedinja: { encounters: ['research'] },
	whismur: { encounters: ['wild'] },
	loudred: { encounters: ['wild'] },
	exploud: { encounters: ['wild'] },
	makuhita: { encounters: ['wild'] },
	hariyama: { encounters: ['wild'] },
	azurill: { encounters: ['egg'] },
	nosepass: { encounters: ['wild'] },
	skitty: { encounters: ['wild'] },
	delcatty: { encounters: ['wild'] },
	sableye: { encounters: ['wild'] },
	mawile: { encounters: ['wild'] },
	aron: { encounters: ['wild'] },
	lairon: { encounters: ['wild'] },
	aggron: { encounters: ['wild'] },
	meditite: { encounters: ['wild'] },
	medicham: { encounters: ['wild'] },
	electrike: { encounters: ['wild'] },
	manectric: { encounters: ['wild'] },
	plusle: { encounters: ['wild'] },
	minun: { encounters: ['wild'] },
	volbeat: { encounters: ['wild'] },
	illumise: { encounters: ['wild'] },
	roselia: { encounters: ['wild'] },
	gulpin: { encounters: ['wild'] },
	swalot: { encounters: ['wild'] },
	carvanha: { encounters: ['wild'] },
	sharpedo: { encounters: ['wild'] },
	wailmer: { encounters: ['wild'] },
	wailord: { encounters: ['wild'] },
	numel: { encounters: ['wild'] },
	camerupt: { encounters: ['wild'] },
	torkoal: { encounters: ['wild'] },
	spoink: { encounters: ['wild'] },
	grumpig: { encounters: ['wild'] },
	trapinch: { encounters: ['wild'] },
	vibrava: { encounters: ['wild'] },
	flygon: { encounters: ['wild'] },
	cacnea: { encounters: ['wild'] },
	cacturne: { encounters: ['wild'] },
	swablu: { encounters: ['wild'] },
	altaria: { encounters: ['wild'] },
	zangoose: { encounters: ['wild'] },
	seviper: { encounters: ['wild'] },
	lunatone: { encounters: ['wild'] },
	solrock: { encounters: ['wild'] },
	barboach: { encounters: ['wild'] },
	whiscash: { encounters: ['wild'] },
	corphish: { encounters: ['wild'] },
	crawdaunt: { encounters: ['wild'] },
	baltoy: { encounters: ['wild'] },
	claydol: { encounters: ['wild'] },
	lileep: { encounters: ['wild'] },
	cradily: { encounters: ['wild'] },
	anorith: { encounters: ['wild'] },
	armaldo: { encounters: ['wild'] },
	feebas: { encounters: ['wild'] },
	milotic: { encounters: ['wild'] },
	castform: { encounters: ['wild'] },
	kecleon: { encounters: ['wild'] },
	shuppet: { encounters: ['wild'] },
	banette: { encounters: ['wild'] },
	duskull: { encounters: ['wild'] },
	dusclops: { encounters: ['wild'] },
	tropius: { encounters: ['wild'] },
	chimecho: { encounters: ['wild'] },
	absol: { encounters: ['wild'] },
	wynaut: { encounters: ['egg'] },
	snorunt: { encounters: ['wild'] },
	glalie: { encounters: ['wild'] },
	spheal: { encounters: ['wild'] },
	sealeo: { encounters: ['wild'] },
	walrein: { encounters: ['wild'] },
	clamperl: { encounters: ['wild'] },
	gorebyss: { encounters: ['wild'] },
	huntail: { encounters: ['wild'] },
	relicanth: { encounters: ['wild'] },
	luvdisc: { encounters: ['wild'] },
	bagon: { encounters: ['wild'] },
	shelgon: { encounters: ['wild'] },
	salamence: { encounters: ['wild'] },
	beldum: { encounters: ['wild'] },
	metang: { encounters: ['wild'] },
	metagross: { encounters: ['wild'] },
	regirock: { encounters: ['giovanni', 'raid', 'research', 'specialtrade'] },
	regice: { encounters: ['giovanni', 'raid', 'research', 'specialtrade'] },
	registeel: { encounters: ['giovanni', 'raid', 'research', 'specialtrade'] },
	latias: { encounters: ['wild'] },
	latios: { encounters: ['wild'] },
	kyogre: { encounters: ['giovanni', 'raid', 'research', 'specialtrade'] },
	groudon: { encounters: ['giovanni', 'raid', 'research', 'specialtrade'] },
	rayquaza: { encounters: ['raid', 'research', 'specialtrade'] },
	jirachi: { encounters: ['research', 'notrade'] },
	deoxys: { encounters: ['raid', 'specialtrade'] },
	turtwig: { encounters: ['wild'] },
	grotle: { encounters: ['wild'] },
	torterra: { encounters: ['wild'] },
	chimchar: { encounters: ['wild'] },
	monferno: { encounters: ['wild'] },
	infernape: { encounters: ['wild'] },
	piplup: { encounters: ['wild'] },
	prinplup: { encounters: ['wild'] },
	empoleon: { encounters: ['wild'] },
	starly: { encounters: ['wild'] },
	staravia: { encounters: ['wild'] },
	staraptor: { encounters: ['wild'] },
	bidoof: { encounters: ['wild'] },
	bibarel: { encounters: ['wild'] },
	kricketot: { encounters: ['wild'] },
	kricketune: { encounters: ['wild'] },
	shinx: { encounters: ['wild'] },
	luxio: { encounters: ['wild'] },
	luxray: { encounters: ['wild'] },
	budew: { encounters: ['egg'] },
	roserade: { encounters: ['wild'] },
	cranidos: { encounters: ['wild'] },
	rampardos: { encounters: ['wild'] },
	shieldon: { encounters: ['wild'] },
	bastiodon: { encounters: ['wild'] },
	burmy: { encounters: ['wild'] },
	wormadam: { encounters: ['wild'] },
	wormadamsandy: { encounters: ['wild'] },
	wormadamtrash: { encounters: ['wild'] },
	mothim: { encounters: ['wild'] },
	combee: { encounters: ['wild'] },
	vespiquen: { encounters: ['wild'] },
	pachirisu: { encounters: ['wild'] },
	buizel: { encounters: ['wild'] },
	floatzel: { encounters: ['wild'] },
	cherubi: { encounters: ['wild'] },
	shellos: { encounters: ['wild'] },
	shelloseast: { encounters: ['wild'] },
	gastrodon: { encounters: ['wild'] },
	gastrodoneast: { encounters: ['wild'] },
	ambipom: { encounters: ['wild'] },
	drifloon: { encounters: ['wild'] },
	drifblim: { encounters: ['wild'] },
	buneary: { encounters: ['wild'] },
	lopunny: { encounters: ['wild'] },
	mismagius: { encounters: ['wild'] },
	honchkrow: { encounters: ['wild'] },
	glameow: { encounters: ['wild'] },
	purugly: { encounters: ['wild'] },
	chingling: { encounters: ['egg'] },
	stunky: { encounters: ['wild'] },
	skuntank: { encounters: ['wild'] },
	bronzor: { encounters: ['wild'] },
	bronzong: { encounters: ['wild'] },
	bonsly: { encounters: ['egg'] },
	mimejr: { encounters: ['egg'] },
	happiny: { encounters: ['egg'] },
	chatot: { encounters: ['wild'] },
	spiritomb: { encounters: ['research'] },
	gible: { encounters: ['wild'] },
	gabite: { encounters: ['wild'] },
	garchomp: { encounters: ['wild'] },
	munchlax: { encounters: ['egg'] },
	riolu: { encounters: ['egg'] },
	lucario: { encounters: ['wild'] },
	hippopotas: { encounters: ['wild'] },
	hippowdon: { encounters: ['wild'] },
	skorupi: { encounters: ['wild'] },
	drapion: { encounters: ['wild'] },
	croagunk: { encounters: ['wild'] },
	toxicroak: { encounters: ['wild'] },
	carnivine: { encounters: ['wild'] },
	finneon: { encounters: ['wild'] },
	lumineon: { encounters: ['wild'] },
	mantyke: { encounters: ['egg'] },
	snover: { encounters: ['wild'] },
	abomasnow: { encounters: ['wild'] },
	weavile: { encounters: ['wild'] },
	magnezone: { encounters: ['wild'] },
	lickilicky: { encounters: ['wild'] },
	rhyperior: { encounters: ['wild'] },
	tangrowth: { encounters: ['wild'] },
	electivire: { encounters: ['wild'] },
	magmortar: { encounters: ['wild'] },
	togekiss: { encounters: ['wild'] },
	yanmega: { encounters: ['wild'] },
	leafeon: { encounters: ['wild'] },
	glaceon: { encounters: ['wild'] },
	gliscor: { encounters: ['wild'] },
	mamoswine: { encounters: ['wild'] },
	porygonz: { encounters: ['wild'] },
	gallade: { encounters: ['wild'] },
	probopass: { encounters: ['wild'] },
	dusknoir: { encounters: ['wild'] },
	froslass: { encounters: ['wild'] },
	rotom: { encounters: ['wild'] },
	uxie: { encounters: ['wild'] },
	mesprit: { encounters: ['wild'] },
	azelf: { encounters: ['wild'] },
	dialga: { encounters: ['raid', 'specialtrade'] },
	palkia: { encounters: ['giovanni', 'raid', 'specialtrade'] },
	heatran: { encounters: ['giovanni', 'raid', 'research', 'specialtrade'] },
	regigigas: { encounters: ['giovanni', 'raid', 'research', 'specialtrade'] },
	giratina: { encounters: ['raid', 'specialtrade'] },
	cresselia: { encounters: ['giovanni', 'raid', 'research', 'specialtrade'] },
	darkrai: { encounters: ['raid', 'research', 'notrade'] },
	shaymin: { encounters: ['research', 'notrade'] },
	victini: { encounters: ['research', 'noshiny', 'notrade'] },
	snivy: { encounters: ['wild'] },
	servine: { encounters: ['wild'] },
	serperior: { encounters: ['wild'] },
	tepig: { encounters: ['wild'] },
	pignite: { encounters: ['wild'] },
	emboar: { encounters: ['wild'] },
	oshawott: { encounters: ['wild'] },
	dewott: { encounters: ['wild'] },
	samurott: { encounters: ['wild'] },
	samurotthisui: { encounters: ['raid'] },
	patrat: { encounters: ['wild'] },
	watchog: { encounters: ['wild'] },
	lillipup: { encounters: ['wild'] },
	herdier: { encounters: ['wild'] },
	stoutland: { encounters: ['wild'] },
	purrloin: { encounters: ['wild'] },
	liepard: { encounters: ['wild'] },
	pansage: { encounters: ['wild'] },
	simisage: { encounters: ['wild'] },
	pansear: { encounters: ['wild'] },
	simisear: { encounters: ['wild'] },
	panpour: { encounters: ['wild'] },
	simipour: { encounters: ['wild'] },
	munna: { encounters: ['wild'] },
	musharna: { encounters: ['wild'] },
	pidove: { encounters: ['wild'] },
	tranquill: { encounters: ['wild'] },
	unfezant: { encounters: ['wild'] },
	blitzle: { encounters: ['wild'] },
	zebstrika: { encounters: ['wild'] },
	roggenrola: { encounters: ['wild'] },
	boldore: { encounters: ['wild'] },
	gigalith: { encounters: ['wild'] },
	woobat: { encounters: ['wild'] },
	swoobat: { encounters: ['wild'] },
	drilbur: { encounters: ['wild'] },
	excadrill: { encounters: ['wild'] },
	audino: { encounters: ['wild'] },
	timburr: { encounters: ['wild'] },
	gurdurr: { encounters: ['wild'] },
	conkeldurr: { encounters: ['wild'] },
	tympole: { encounters: ['wild'] },
	palpitoad: { encounters: ['wild'] },
	seismitoad: { encounters: ['wild'] },
	throh: { encounters: ['wild'] },
	sawk: { encounters: ['wild'] },
	sewaddle: { encounters: ['wild'] },
	swadloon: { encounters: ['wild'] },
	leavanny: { encounters: ['wild'] },
	venipede: { encounters: ['wild'] },
	whirlipede: { encounters: ['wild'] },
	scolipede: { encounters: ['wild'] },
	cottonee: { encounters: ['wild'] },
	whimsicott: { encounters: ['wild'] },
	petilil: { encounters: ['wild'] },
	lilligant: { encounters: ['wild'] },
	basculin: { encounters: ['wild', 'noshiny'] }, // Shiny available 2025-02-21
	basculinbluestriped: { encounters: ['wild', 'noshiny'] }, // Shiny available 2025-02-21
	basculinwhitestriped: { encounters: ['wild'] },
	sandile: { encounters: ['12kmegg', 'raid', 'research'] },
	krokorok: { encounters: ['12kmegg', 'raid', 'research'] },
	krookodile: { encounters: ['12kmegg', 'raid', 'research'] },
	darumaka: { encounters: ['wild'] },
	darumakagalar: { encounters: ['wild'] },
	darmanitan: { encounters: ['wild'] },
	darmanitangalar: { encounters: ['wild'] },
	maractus: { encounters: ['wild', 'noshiny'] }, // Shiny available 2025-02-21
	dwebble: { encounters: ['wild'] },
	crustle: { encounters: ['wild'] },
	scraggy: { encounters: ['wild'] },
	scrafty: { encounters: ['wild'] },
	sigilyph: { encounters: ['wild'] },
	yamask: { encounters: ['wild'] },
	yamaskgalar: { encounters: ['egg', 'raid', 'research'] },
	cofagrigus: { encounters: ['wild'] },
	tirtouga: { encounters: ['wild'] },
	carracosta: { encounters: ['wild'] },
	archen: { encounters: ['wild'] },
	archeops: { encounters: ['wild'] },
	trubbish: { encounters: ['wild'] },
	garbodor: { encounters: ['wild'] },
	zorua: { encounters: ['wild'] },
	zoroark: { encounters: ['wild'] },
	minccino: { encounters: ['wild'] },
	cinccino: { encounters: ['wild'] },
	gothita: { encounters: ['wild'] },
	gothorita: { encounters: ['wild'] },
	gothitelle: { encounters: ['wild'] },
	solosis: { encounters: ['wild'] },
	duosion: { encounters: ['wild'] },
	reuniclus: { encounters: ['wild'] },
	ducklett: { encounters: ['wild'] },
	swanna: { encounters: ['wild'] },
	vanillite: { encounters: ['wild'] },
	vanillish: { encounters: ['wild'] },
	vanilluxe: { encounters: ['wild'] },
	deerling: { encounters: ['wild', 'noshiny'] }, // Shiny available 2025-02-21
	deerlingsummer: { encounters: ['wild', 'noshiny'] },
	deerlingautumn: { encounters: ['wild', 'noshiny'] },
	deerlingwinter: { encounters: ['wild', 'noshiny'] },
	sawsbuck: { encounters: ['wild', 'noshiny'] },
	sawsbucksummer: { encounters: ['wild', 'noshiny'] },
	sawsbuckautumn: { encounters: ['wild', 'noshiny'] },
	sawsbuckwinter: { encounters: ['wild', 'noshiny'] },
	emolga: { encounters: ['wild'] },
	karrablast: { encounters: ['wild'] },
	escavalier: { encounters: ['wild'] },
	foongus: { encounters: ['wild'] },
	amoonguss: { encounters: ['wild'] },
	frillish: { encounters: ['wild'] },
	jellicent: { encounters: ['wild'] },
	alomomola: { encounters: ['wild'] },
	joltik: { encounters: ['wild'] },
	galvantula: { encounters: ['wild'] },
	ferroseed: { encounters: ['wild'] },
	ferrothorn: { encounters: ['wild'] },
	klink: { encounters: ['wild'] },
	klang: { encounters: ['wild'] },
	klinklang: { encounters: ['wild'] },
	tynamo: { encounters: ['wild'] },
	eelektrik: { encounters: ['wild'] },
	eelektross: { encounters: ['wild'] },
	elgyem: { encounters: ['wild'] },
	beheeyem: { encounters: ['wild'] },
	litwick: { encounters: ['wild'] },
	lampent: { encounters: ['wild'] },
	chandelure: { encounters: ['wild'] },
	axew: { encounters: ['wild'] },
	fraxure: { encounters: ['wild'] },
	haxorus: { encounters: ['wild'] },
	cubchoo: { encounters: ['wild'] },
	beartic: { encounters: ['wild'] },
	cryogonal: { encounters: ['wild'] },
	shelmet: { encounters: ['wild'] },
	accelgor: { encounters: ['wild'] },
	stunfisk: { encounters: ['wild'] },
	stunfiskgalar: { encounters: ['wild'] },
	mienfoo: { encounters: ['wild'] },
	mienshao: { encounters: ['wild'] },
	druddigon: { encounters: ['wild'] },
	golett: { encounters: ['wild'] },
	golurk: { encounters: ['wild'] },
	pawniard: { encounters: ['wild'] },
	bisharp: { encounters: ['wild'] },
	bouffalant: { encounters: ['wild'] },
	rufflet: { encounters: ['wild'] },
	braviary: { encounters: ['wild'] },
	braviaryhisui: { encounters: ['wild'] },
	vullaby: { encounters: ['wild'] },
	mandibuzz: { encounters: ['wild'] },
	heatmor: { encounters: ['wild'] },
	durant: { encounters: ['wild'] },
	deino: { encounters: ['wild'] },
	zweilous: { encounters: ['wild'] },
	hydreigon: { encounters: ['wild'] },
	larvesta: { encounters: ['egg'] },
	volcarona: { encounters: ['egg'] },
	cobalion: { encounters: ['raid', 'specialtrade'] }, // research available 2025-02-24
	terrakion: { encounters: ['raid', 'specialtrade'] }, // research available 2025-02-24
	virizion: { encounters: ['raid', 'specialtrade'] }, // research available 2025-02-24
	tornadus: { encounters: ['raid', 'research', 'specialtrade'] }, // research available 2025-02-21
	thundurus: { encounters: ['raid', 'research', 'specialtrade'] }, // research available 2025-02-21
	reshiram: { encounters: ['raid', 'specialtrade'] },
	zekrom: { encounters: ['raid', 'specialtrade'] },
	landorus: { encounters: ['raid', 'research', 'specialtrade'] }, // research available 2025-02-21
	kyurem: { encounters: ['raid', 'specialtrade'] },
	// Kyurem-Black/White are not directly obtained from Pokemon GO but should be able to have legal Pokemon GO origin
	kyuremblack: { encounters: ['raid', 'specialtrade'] },
	kyuremwhite: { encounters: ['raid', 'specialtrade'] },
	keldeo: { encounters: ['research', 'noshiny', 'notrade'] },
	meloetta: { encounters: ['research', 'noshiny', 'notrade'] },
	genesect: { encounters: ['raid', 'research', 'notrade'] },
	chespin: { encounters: ['wild'] },
	quilladin: { encounters: ['wild'] },
	chesnaught: { encounters: ['wild'] },
	fennekin: { encounters: ['wild'] },
	braixen: { encounters: ['wild'] },
	delphox: { encounters: ['wild'] },
	froakie: { encounters: ['wild'] },
	frogadier: { encounters: ['wild'] },
	greninja: { encounters: ['wild'] },
	bunnelby: { encounters: ['wild'] },
	diggersby: { encounters: ['wild'] },
	fletchling: { encounters: ['wild'] },
	fletchinder: { encounters: ['wild'] },
	talonflame: { encounters: ['wild'] },
	// Scatterbug is actually obtained in a special type of encounter,
	// but the level and IV floors are the same as research encounters
	scatterbug: { encounters: ['research'] },
	spewpa: { encounters: ['research'] },
	vivillon: { encounters: ['research'] },
	vivillonarchipelago: { encounters: ['research'] },
	vivilloncontinent: { encounters: ['research'] },
	vivillonelegant: { encounters: ['research'] },
	vivillongarden: { encounters: ['research'] },
	vivillonhighplains: { encounters: ['research'] },
	vivillonicysnow: { encounters: ['research'] },
	vivillonjungle: { encounters: ['research'] },
	vivillonmarine: { encounters: ['research'] },
	vivillonmodern: { encounters: ['research'] },
	vivillonmonsoon: { encounters: ['research'] },
	vivillonocean: { encounters: ['research'] },
	vivillonpolar: { encounters: ['research'] },
	vivillonriver: { encounters: ['research'] },
	vivillonsandstorm: { encounters: ['research'] },
	vivillonsavanna: { encounters: ['research'] },
	vivillonsun: { encounters: ['research'] },
	vivillontundra: { encounters: ['research'] },
	litleo: { encounters: ['wild'] },
	pyroar: { encounters: ['wild'] },
	flabebe: { encounters: ['wild'] },
	flabebeblue: { encounters: ['wild'] },
	flabebeorange: { encounters: ['wild'] },
	flabebewhite: { encounters: ['wild'] },
	flabebeyellow: { encounters: ['wild'] },
	floette: { encounters: ['wild'] },
	floetteblue: { encounters: ['wild'] },
	floetteorange: { encounters: ['wild'] },
	floettewhite: { encounters: ['wild'] },
	floetteyellow: { encounters: ['wild'] },
	florges: { encounters: ['wild'] },
	florgesblue: { encounters: ['wild'] },
	florgesorange: { encounters: ['wild'] },
	florgeswhite: { encounters: ['wild'] },
	florgesyellow: { encounters: ['wild'] },
	pancham: { encounters: ['wild'] },
	pangoro: { encounters: ['wild'] },
	furfrou: { encounters: ['wild'] },
	furfroudandy: { encounters: ['wild'] },
	furfroudebutante: { encounters: ['wild'] },
	furfroudiamond: { encounters: ['wild'] },
	furfrouheart: { encounters: ['wild'] },
	furfroukabuki: { encounters: ['wild'] },
	furfroulareine: { encounters: ['wild'] },
	furfroumatron: { encounters: ['wild'] },
	furfroupharaoh: { encounters: ['wild'] },
	furfroustar: { encounters: ['wild'] },
	espurr: { encounters: ['wild'] },
	meowstic: { encounters: ['wild'] },
	meowsticf: { encounters: ['wild'] },
	spritzee: { encounters: ['wild'] },
	aromatisse: { encounters: ['wild'] },
	swirlix: { encounters: ['wild'] },
	slurpuff: { encounters: ['wild'] },
	inkay: { encounters: ['wild'] },
	malamar: { encounters: ['wild'] },
	binacle: { encounters: ['wild'] },
	barbaracle: { encounters: ['wild'] },
	skrelp: { encounters: ['wild'] },
	dragalge: { encounters: ['wild'] },
	clauncher: { encounters: ['wild'] },
	clawitzer: { encounters: ['wild'] },
	helioptile: { encounters: ['wild'] },
	heliolisk: { encounters: ['wild'] },
	tyrunt: { encounters: ['wild'] },
	tyrantrum: { encounters: ['wild'] },
	amaura: { encounters: ['wild'] },
	aurorus: { encounters: ['wild'] },
	sylveon: { encounters: ['wild'] },
	hawlucha: { encounters: ['wild', 'noshiny'] },
	dedenne: { encounters: ['wild'] },
	carbink: { encounters: ['research', 'noshiny'] },
	goomy: { encounters: ['wild'] },
	sliggoo: { encounters: ['wild'] },
	goodra: { encounters: ['wild'] },
	klefki: { encounters: ['wild', 'noshiny'] },
	phantump: { encounters: ['wild'] },
	trevenant: { encounters: ['wild'] },
	pumpkaboo: { encounters: ['wild'] },
	pumpkaboolarge: { encounters: ['wild'] },
	pumpkaboosmall: { encounters: ['wild'] },
	pumpkaboosuper: { encounters: ['wild'] },
	gourgeist: { encounters: ['wild'] },
	gourgeistlarge: { encounters: ['wild'] },
	gourgeistsmall: { encounters: ['wild'] },
	gourgeistsuper: { encounters: ['wild'] },
	bergmite: { encounters: ['wild'] },
	avalugg: { encounters: ['wild'] },
	avalugghisui: { encounters: ['wild'] },
	noibat: { encounters: ['wild'] },
	noivern: { encounters: ['wild'] },
	xerneas: { encounters: ['raid', 'specialtrade'] },
	yveltal: { encounters: ['raid', 'specialtrade'] },
	// zygarde: {encounters: ['research', 'noshiny', 'notrade']},
	diancie: { encounters: ['research', 'noshiny', 'notrade'] },
	hoopa: { encounters: ['raid', 'research', 'noshiny', 'notrade'] },
	rowlet: { encounters: ['wild'] },
	dartrix: { encounters: ['wild'] },
	decidueye: { encounters: ['wild'] },
	decidueyehisui: { encounters: ['raid'] },
	litten: { encounters: ['wild'] },
	torracat: { encounters: ['wild'] },
	incineroar: { encounters: ['wild'] },
	popplio: { encounters: ['wild'] },
	brionne: { encounters: ['wild'] },
	primarina: { encounters: ['wild'] },
	pikipek: { encounters: ['wild', 'noshiny'] },
	trumbeak: { encounters: ['wild', 'noshiny'] },
	toucannon: { encounters: ['wild', 'noshiny'] },
	yungoos: { encounters: ['wild'] },
	gumshoos: { encounters: ['wild'] },
	grubbin: { encounters: ['wild'] },
	charjabug: { encounters: ['wild'] },
	vikavolt: { encounters: ['wild'] },
	crabrawler: { encounters: ['wild'] },
	crabominable: { encounters: ['wild'] },
	oricorio: { encounters: ['wild'] },
	cutiefly: { encounters: ['wild'] },
	ribombee: { encounters: ['wild'] },
	rockruff: { encounters: ['wild'] },
	rockruffdusk: { encounters: ['wild'] },
	lycanroc: { encounters: ['wild'] },
	lycanrocmidnight: { encounters: ['wild'] },
	lycanrocdusk: { encounters: ['wild'] },
	mareanie: { encounters: ['wild'] },
	toxapex: { encounters: ['wild'] },
	// mudbray: {encounters: ['wild']}, available 2025-03-29
	// mudsdale: {encounters: ['wild']},
	dewpider: { encounters: ['wild'] },
	araquanid: { encounters: ['wild'] },
	fomantis: { encounters: ['wild'] },
	lurantis: { encounters: ['wild'] },
	morelull: { encounters: ['wild'] },
	shiinotic: { encounters: ['wild'] },
	salandit: { encounters: ['12kmegg', 'research', 'noshiny'] },
	salazzle: { encounters: ['12kmegg', 'research', 'noshiny'] },
	stufful: { encounters: ['wild'] },
	bewear: { encounters: ['wild'] },
	bounsweet: { encounters: ['wild'] },
	steenee: { encounters: ['wild'] },
	tsareena: { encounters: ['wild'] },
	comfey: { encounters: ['wild', 'noshiny'] },
	oranguru: { encounters: ['wild'] },
	passimian: { encounters: ['wild'] },
	wimpod: { encounters: ['wild'] },
	golisopod: { encounters: ['wild'] },
	sandygast: { encounters: ['wild'] },
	palossand: { encounters: ['wild'] },
	komala: { encounters: ['wild'] },
	turtonator: { encounters: ['egg', 'raid', 'research'] },
	togedemaru: { encounters: ['wild'] },
	bruxish: { encounters: ['wild', 'noshiny'] },
	drampa: { encounters: ['egg', 'raid', 'research'] },
	dhelmise: { encounters: ['raid', 'noshiny'] },
	jangmoo: { encounters: ['wild'] },
	hakamoo: { encounters: ['wild'] },
	kommoo: { encounters: ['wild'] },
	tapukoko: { encounters: ['raid'] },
	tapulele: { encounters: ['raid'] },
	tapubulu: { encounters: ['raid'] },
	tapufini: { encounters: ['raid'] },
	cosmog: { encounters: ['research', 'noshiny', 'specialtrade'] },
	cosmoem: { encounters: ['research', 'noshiny', 'specialtrade'] },
	solgaleo: { encounters: ['research', 'noshiny', 'specialtrade'] },
	lunala: { encounters: ['research', 'noshiny', 'specialtrade'] },
	nihilego: { encounters: ['raid', 'research', 'specialtrade'] },
	buzzwole: { encounters: ['raid', 'research', 'specialtrade'] },
	pheromosa: { encounters: ['raid', 'research', 'specialtrade'] },
	xurkitree: { encounters: ['raid', 'research', 'specialtrade'] },
	celesteela: { encounters: ['raid', 'research', 'specialtrade'] },
	kartana: { encounters: ['raid', 'research', 'specialtrade'] },
	guzzlord: { encounters: ['raid', 'research', 'specialtrade'] },
	poipole: { encounters: ['research', 'noshiny', 'specialtrade'] },
	naganadel: { encounters: ['research', 'noshiny', 'specialtrade'] },
	stakataka: { encounters: ['raid', 'research', 'noshiny', 'specialtrade'] },
	blacephalon: { encounters: ['raid', 'research', 'noshiny', 'specialtrade'] },
	necrozma: { encounters: ['raid', 'specialtrade'] },
	meltan: { encounters: ['wild'] },
	melmetal: { encounters: ['wild'] },
	grookey: { encounters: ['wild', 'noshiny'] },
	thwackey: { encounters: ['wild', 'noshiny'] },
	rillaboom: { encounters: ['wild', 'noshiny'] },
	scorbunny: { encounters: ['wild', 'noshiny'] },
	raboot: { encounters: ['wild', 'noshiny'] },
	cinderace: { encounters: ['wild', 'noshiny'] },
	sobble: { encounters: ['wild', 'noshiny'] },
	drizzile: { encounters: ['wild', 'noshiny'] },
	inteleon: { encounters: ['wild', 'noshiny'] },
	skwovet: { encounters: ['wild'] },
	greedent: { encounters: ['wild'] },
	rookidee: { encounters: ['wild', 'noshiny'] },
	corvisquire: { encounters: ['wild', 'noshiny'] },
	corviknight: { encounters: ['wild', 'noshiny'] },
	toxel: { encounters: ['egg'] },
	toxtricity: { encounters: ['egg', 'raid', 'research'] },
	toxtricitylowkey: { encounters: ['egg', 'raid', 'research'] },
	sinistea: { encounters: ['raid', 'research', 'noshiny'] },
	sinisteaantique: { encounters: ['raid', 'research', 'noshiny'] },
	polteageist: { encounters: ['raid', 'research', 'noshiny'] },
	polteageistantique: { encounters: ['raid', 'research', 'noshiny'] },
	hatenna: { encounters: ['wild', 'noshiny'] },
	hattrem: { encounters: ['wild', 'noshiny'] },
	hatterene: { encounters: ['wild', 'noshiny'] },
	obstagoon: { encounters: ['wild'] },
	perrserker: { encounters: ['wild'] },
	cursola: { encounters: ['egg'] },
	sirfetchd: { encounters: ['wild'] },
	mrrime: { encounters: ['wild'] },
	runerigus: { encounters: ['egg', 'raid', 'research'] },
	falinks: { encounters: ['wild'] },
	stonjourner: { encounters: ['wild', 'noshiny'] },
	morpeko: { encounters: ['wild', 'noshiny'] },
	dreepy: { encounters: ['wild', 'noshiny'] },
	drakloak: { encounters: ['wild', 'noshiny'] },
	dragapult: { encounters: ['wild', 'noshiny'] },
	zacian: { encounters: ['raid', 'specialtrade'] },
	zamazenta: { encounters: ['raid', 'specialtrade'] },
	zarude: { encounters: ['research', 'noshiny', 'notrade'] },
	regieleki: { encounters: ['raid', 'specialtrade'] },
	regidrago: { encounters: ['raid', 'specialtrade'] },
	wyrdeer: { encounters: ['wild'] },
	kleavor: { encounters: ['wild'] },
	ursaluna: { encounters: ['wild'] },
	sneasler: { encounters: ['wild'] },
	overqwil: { encounters: ['wild'] },
	enamorus: { encounters: ['raid', 'noshiny', 'specialtrade'] },
	sprigatito: { encounters: ['wild'] },
	floragato: { encounters: ['wild'] },
	meowscarada: { encounters: ['wild'] },
	fuecoco: { encounters: ['wild', 'noshiny'] }, // Shiny available 2025-03-08
	crocalor: { encounters: ['wild', 'noshiny'] },
	skeledirge: { encounters: ['wild', 'noshiny'] },
	quaxly: { encounters: ['wild', 'noshiny'] },
	quaxwell: { encounters: ['wild', 'noshiny'] },
	quaquaval: { encounters: ['wild', 'noshiny'] },
	lechonk: { encounters: ['wild'] },
	oinkologne: { encounters: ['wild'] },
	oinkolognef: { encounters: ['wild'] },
	nymble: { encounters: ['wild'] },
	lokix: { encounters: ['wild'] },
	tandemaus: { encounters: ['research', 'noshiny'] },
	maushold: { encounters: ['research', 'noshiny'] },
	mausholdfour: { encounters: ['research', 'noshiny'] },
	fidough: { encounters: ['wild', 'noshiny'] },
	dachsbun: { encounters: ['wild', 'noshiny'] },
	pawmi: { encounters: ['wild', 'noshiny'] },
	pawmo: { encounters: ['wild', 'noshiny'] },
	pawmot: { encounters: ['wild', 'noshiny'] },
	smoliv: { encounters: ['wild'] },
	dolliv: { encounters: ['wild'] },
	arboliva: { encounters: ['wild'] },
	charcadet: { encounters: ['egg', 'research', 'noshiny'] },
	armarouge: { encounters: ['egg', 'research', 'noshiny'] },
	ceruledge: { encounters: ['egg', 'research', 'noshiny'] },
	tadbulb: { encounters: ['wild', 'noshiny'] },
	bellibolt: { encounters: ['wild', 'noshiny'] },
	shroodle: { encounters: ['12kmegg', 'noshiny'] },
	grafaiai: { encounters: ['12kmegg', 'noshiny'] },
	wiglett: { encounters: ['wild', 'noshiny'] },
	wugtrio: { encounters: ['wild', 'noshiny'] },
	varoom: { encounters: ['12kmegg', 'noshiny'] },
	revavroom: { encounters: ['12kmegg', 'noshiny'] },
	greavard: { encounters: ['wild', 'noshiny'] },
	houndstone: { encounters: ['wild', 'noshiny'] },
	cetoddle: { encounters: ['wild'] },
	cetitan: { encounters: ['wild'] },
	annihilape: { encounters: ['wild'] },
	clodsire: { encounters: ['wild', 'noshiny'] },
	frigibax: { encounters: ['wild', 'noshiny'] },
	arctibax: { encounters: ['wild', 'noshiny'] },
	baxcalibur: { encounters: ['wild', 'noshiny'] },
	gimmighoulroaming: { encounters: ['wild', 'noshiny'] },
	gholdengo: { encounters: ['wild', 'noshiny'] },
};
